module.exports = __webpack_public_path__ + "assets/img/icon11-menu.d6f793a5.svg";